import { render } from "./AddEditForm.vue?vue&type=template&id=b3cf7b84"
import script from "./AddEditForm.vue?vue&type=script&lang=js"
export * from "./AddEditForm.vue?vue&type=script&lang=js"

import "./AddEditForm.vue?vue&type=style&index=0&id=b3cf7b84&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__